import { apiSlice } from "app/api/apiSlice"


export const restoreApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
    
        requireReset: builder.mutation({
            query: (email) => {
                return {
                    url: '/auth/reset-password',
                    params: {
                        email: email
                    }
                }
            }
        }),

        validateOtp: builder.mutation({
            query: otpPayload => ({
                url: '/auth/validate',
                method: 'POST',
                body: { ...otpPayload }
            })
        }),

        updatePassword: builder.mutation({
            query: otpPayload => ({
                url: '/auth/new-password',
                method: 'POST',
                body: { ...otpPayload }
            })
        }),
    })
})

export const {
    useRequireResetMutation,
    useValidateOtpMutation,
    useUpdatePasswordMutation
} = restoreApiSlice